<template>
  <div class="branchHome">
    <baseBg bgUrl="branchbg"></baseBg>
    <div class="he50"></div>
    <div class="branchTitle w-main">
      <p>磁罗经技术服务部上海分部</p>
      <div class="line"></div>
    </div>
    <div class="he50"></div>
    <div class="branchBox w-main">
      <div class="left">
        <div class="item">
          <div class="itemImg">
            <el-image :src="img.icon1" fit="fill"></el-image>
          </div>
          <div class="itemRight">
            <div class="titel">联系人</div>
            <div class="text">许凯音</div>
          </div>
        </div>
        <div class="item">
          <div class="itemImg">
            <el-image :src="img.icon2" fit="fill"></el-image>
          </div>
          <div class="itemRight">
            <div class="titel">联系邮箱</div>
            <div class="text">810872132@qq.com</div>
          </div>
        </div>
        <div class="item">
          <div class="itemImg">
            <el-image :src="img.icon1" fit="fill"></el-image>
          </div>
          <div class="itemRight">
            <div class="titel">联系地址</div>
            <div class="text">
              上海市虹口区高阳路
              <br />147号405室
            </div>
          </div>
        </div>
        <div class="item">
          <div class="itemImg">
            <el-image :src="img.icon4" fit="fill"></el-image>
          </div>
          <div class="itemRight">
            <div class="titel">联系电话</div>
            <div class="text">
              65967017
              <br />15601619621
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <img src="../../../assets/img/branch/bg.png" alt />
      </div>
    </div>
    <div class="he50"></div>
    <div class="linedashed w-main"></div>
    <div class="he50"></div>
    <div class="branchHeard w-main">上海分部校正人员信息</div>
    <div class="branchbody w-main">
      <span>范顺军</span>
      <span>沈浦根</span>
      <span>秦臻</span>
      <span>殷家华</span>
      <span>杨忠伟</span>
      <span>曹炯</span>
      <span>徐磊鉴</span>
      <span>陈炳坤</span>
      <span>羊锐锐</span>
      <span>王智</span>
      <span>曾华</span>
      <span>陈军伟</span>
      <span>周夏</span>
    </div>
    <div class="he50"></div>
    <div class="he50"></div>
  </div>
</template>

<script>
import baseBg from "@/components/pc/base/bg.vue";
import icon1 from "@/assets/img/branch/item1.png";
import icon2 from "@/assets/img/branch/item2.png";
import icon4 from "@/assets/img/branch/item4.png";
export default {
  data() {
    return {
      img: {
        icon1,
        icon2,
        icon4
      }
    };
  },
  components: {
    baseBg
  }
};
</script>

<style lang="less">
.branchHome {
  .branchTitle {
    font-size: 32px;
    font-weight: bold;
    color: rgba(52, 52, 52, 1);
    line-height: 48px;
  }
  .line {
    margin-top: 10px;
    width: 90px;
    height: 4px;
    background: rgba(108, 44, 102, 1);
    // border: 1px dashed;;
  }
  .linedashed {
    border: 1px dashed rgba(191, 195, 199, 1);
  }
  .branchBox {
    display: flex;
    justify-content: space-between;
    .left {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      width: calc(100% - 500px);
      .item {
        display: flex;
        align-items: center;
        margin-bottom: 40px;
        width: 50%;
        .itemRight {
          margin-left: 20px;
          .titel {
            font-size: 22px;
            font-weight: bold;
            color: rgba(22, 81, 148, 1);
            line-height: 48px;
          }
          .text {
            font-size: 18px;
            font-family: PingFang;
            font-weight: bold;
            color: rgba(52, 52, 52, 1);
            // line-height: 48px;
          }
        }
      }
    }
  }
  .branchHeard {
    height: 64px;
    line-height: 64px;
    padding: 0 30px;
    background: rgba(240, 242, 245, 1);
    font-size: 20px;
    font-weight: bold;
    color: rgba(52, 52, 52, 1);
    box-sizing: border-box;
  }
  .branchbody {
    display: flex;
    justify-content: space-between;
    height: 80px;
    line-height: 80px;
    background: rgba(22, 81, 148, 1);
    span {
      width: 100%;
      text-align: center;
      font-size: 18px;
      font-family: PingFang;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      border-right: 1px solid #ebebeb;
    }
  }
}
</style>
